/**
 * Check the platform type set in the URL.
 * @param platform The platform name (case-insensitive)
 * @param search The query string to parse (default: `location.search`)
 * @returns Returns `null` if the `platform` URL parameter is not set.
 */
export function isUrlQueryPlatform(platform: string, search = location.search): boolean | null {
    const urlParams = new URLSearchParams(search);
    const urlPlatform = urlParams.get('platform');
    if (urlPlatform === null) {
        return null;
    } else {
        return urlPlatform.toLowerCase() === platform.toLowerCase();
    }
}

export enum Feature {
    PostMessageClient = 'pmc',
}

export function getUrlQueryFeatures(search = location.search): string[] {
    const urlParams = new URLSearchParams(search);
    const urlFeat = urlParams.get('feat') ?? '';
    const features = urlFeat.split(',');
    return features;
}

/**
 * A comma separated list of features supported by the platform can be passed via the `feat` query
 * parameter. This function will check if a feature is in that parameter.
 */
export function hasUrlQueryFeature(feature: Feature, search = location.search): boolean {
    const features = getUrlQueryFeatures(search);
    return features.includes(feature);
}
